import { Module } from 'vuex';
import { RootState } from '@/store/store';
import { PendingDocumentsState, initialState } from './pending-documents.state';
import { pendingDocumentsActions } from './pending-documents.actions';
import { pendingDocumentsMutations } from './pending-documents.mutations';

export const pendingDocumentsModule: Module<
  PendingDocumentsState,
  RootState
> = {
  namespaced: true,
  state: initialState,
  mutations: pendingDocumentsMutations,
  actions: pendingDocumentsActions
};
